import React from 'react'

export default function NewsLetter() {
    return (
        <div className=' bg-[#3699fb] p-4 '>
            <div className='max-w-[1240px]  mx-auto md:flex justify-between py-[50px]'>
                <div className='  '>
                    <h1 className='text-[20px] md:text-[40px] font-bold text-white    '>Want to lean latest I.T Skills?</h1>
                    <span className='text-white'>Sign up our new letter to get latest update</span>
                </div>
                <div className=' '>
                    <form action="">
                        <input type="text" placeholder='Enter your email' className='  rounded py-2 mt-4 px-2' />
                        <button type=' submit' className=' bg-black hover:bg-blue-500 text-white font-bold py-2 mt-4 px-2 border border-blue-700 rounded'>Notify Me</button>
                        <p className=' py-3 '>We care about the protection of you data.<br /> Read our <a className=' font-bold no-underline' href="#">Privacy Policy</a> </p>
                    </form>
                </div>


            </div>
        </div>
    )
}
